import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PenaltyComponent } from './penalty.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { DatePipeModule } from 'libraries/date/date.module';
import { DeltaPriceModule } from '../delta-price/delta-price.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { BtnModule } from 'libraries/ui_button/btn.module';

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
        DatePipeModule,
        DeltaPriceModule,
        PricePipeModule,
        PricePipesModule,
        BtnModule
    ],
    declarations: [
        PenaltyComponent,
    ],
    exports: [
        PenaltyComponent,
    ]
})
export class PenaltyModule {}